"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BaseTranslate2 = _interopRequireDefault(require("./_BaseTranslate"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Translations = /*#__PURE__*/function (_BaseTranslate) {
  _inherits(Translations, _BaseTranslate);
  var _super = _createSuper(Translations);
  function Translations() {
    var _super$call;
    _classCallCheck(this, Translations);
    return _super.call(this, (_super$call = {
      something_wrong: {
        nl: 'Er ging iets mis(#digitalDisplay)',
        fr: 'Quelque chose a mal tourné(#digitalDisplay)',
        en: 'Something went wrong(#digitalDisplay)'
      },
      no_books: {
        nl: 'Er zijn geen promofolders of magazines',
        fr: "Il n'y a pas de promotion ou de magazines",
        en: 'There are no promotional folders or magazines'
      },
      package_title: {
        nl: 'Promo & magazine',
        fr: 'Promo & magazine',
        en: 'Promo & magazine'
      },
      recent_magazines: {
        nl: 'Recente magazines',
        fr: 'Magazines récents',
        en: 'Recent magazines'
      },
      recent_promos: {
        nl: 'Recente promo folders',
        fr: 'Promos récents',
        en: 'Recent promo folders'
      },
      load_more: {
        nl: 'Toon meer',
        fr: 'Plus',
        en: 'Load more'
      },
      go_cn: {
        nl: 'Ga naar Catalogusnetwerk',
        fr: 'Accéder au Réseaucatalogue',
        en: 'Go to Cataloguenetwork'
      },
      go_pn: {
        nl: 'Ga naar Promonetwerk',
        fr: 'Accéder au Réseaupromo',
        en: 'Go to Promonetwork'
      }
    }, _defineProperty(_super$call, "go_pn", {
      nl: 'Ga naar Promonetwerk',
      fr: 'Accéder au Réseau Promo',
      en: 'Go to Promo Network'
    }), _defineProperty(_super$call, "recent_date", {
      nl: 'Recentste datum',
      fr: 'date la plus récente',
      en: 'Most recent date'
    }), _defineProperty(_super$call, "oldest_date", {
      nl: 'Oudste datum',
      fr: 'Date la plus ancienne',
      en: 'Oldest date'
    }), _defineProperty(_super$call, "a_z", {
      nl: 'A - Z',
      fr: 'A - Z',
      en: 'A - Z'
    }), _defineProperty(_super$call, "z_a", {
      nl: 'Z - A',
      fr: 'Z - A',
      en: 'Z - A'
    }), _defineProperty(_super$call, "sort", {
      nl: 'Sorteren',
      fr: 'Trier',
      en: 'Sort'
    }), _super$call));
  }
  return _createClass(Translations);
}(_BaseTranslate2["default"]);
exports["default"] = Translations;